// Applies a store's title, tagline and favicon to the page <head> (browser tab, bookmarks, search and link previews).
const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  const prev = el.getAttribute("content");
  el.setAttribute("content", content);
  return () => { if (prev == null) el.remove(); else el.setAttribute("content", prev); };
};

/** Returns a function that restores the previous head. `pageTitle` (optional) is put before the store name. */
export function applyStoreMeta(store, pageTitle) {
  const restore = [];
  const name = store.name || "Store";
  const tagline = (store.tagline || "").trim();
  const title = pageTitle ? `${pageTitle} | ${name}` : tagline ? `${name} – ${tagline}` : name;
  const description = tagline || `Shop online at ${name}.`;
  const prevTitle = document.title;
  document.title = title;
  restore.push(() => { document.title = prevTitle; });

  restore.push(setMeta("name", "description", description));
  restore.push(setMeta("property", "og:title", title));
  restore.push(setMeta("property", "og:description", description));
  restore.push(setMeta("property", "og:site_name", name));
  restore.push(setMeta("property", "og:type", "website"));
  restore.push(setMeta("name", "twitter:title", title));
  restore.push(setMeta("name", "twitter:description", description));
  const image = store.logo || store.favicon;
  if (image) { restore.push(setMeta("property", "og:image", image)); restore.push(setMeta("name", "twitter:image", image)); }

  if (store.favicon) {
    const links = [...document.head.querySelectorAll('link[rel~="icon"]')];
    const saved = links.map((l) => [l, l.getAttribute("href")]);
    links.forEach((l) => l.remove());
    const link = document.createElement("link");
    link.rel = "icon"; link.href = store.favicon;
    document.head.appendChild(link);
    restore.push(() => { link.remove(); saved.forEach(([l]) => document.head.appendChild(l)); });
  }
  return () => restore.reverse().forEach((fn) => fn());
}
